var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYahooSvgrepoCom1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_298_1530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99997 0C15.5231 0 20 4.4775 20 10C20 15.5232 15.5231 20 9.99997 20C4.47681 20 0 15.5231 0 10C0 4.4775 4.47688 0 9.99997 0Z",
    fill: "#720E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5787 7.89378L14.5894 7.89193L14.9206 7.52319L14.9044 7.52195L14.9394 7.46696H10.2988L10.4775 8.10194H11.7438L9.6125 10.0738C9.17751 9.43944 8.15815 7.98131 7.4469 6.88753H8.76875V6.43751L8.78688 6.30817L8.76875 6.30569V6.25317H3.75061V6.88753H5.31996C5.92932 7.39062 8.57124 10.5982 8.66749 10.9044C8.70621 11.1913 8.76127 12.8845 8.64751 13.012C8.51062 13.2088 7.08125 13.1026 6.82937 13.1213L6.81996 13.7432C7.27994 13.7569 8.65994 13.7426 9.12561 13.7426C10.0431 13.7426 11.65 13.7188 11.8762 13.7369L11.9044 13.1482L10.0575 13.1206C10.0188 12.8538 9.97629 11.1694 10.015 10.9856C10.1894 10.4526 13.0231 8.24625 13.3144 8.16318L13.5888 8.10132H14.4451L14.5787 7.89378ZM13.8862 12.2944L14.6887 12.3556L15.6243 8.9244C15.4681 8.91877 14.0487 8.7919 13.8643 8.75751L13.8862 12.2944ZM13.7475 12.8444L13.7519 13.6826L14.1581 13.7163L14.5969 13.747L14.7256 12.927L14.2631 12.9057L13.7475 12.8444Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_298_1530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYahooSvgrepoCom1);
export default __webpack_public_path__ + "static/media/yahoo-svgrepo-com 1.b70b2dd54b96ffb8ed1dfc0d42d02338.svg";
export { ForwardRef as ReactComponent };